// extracted by mini-css-extract-plugin
export default {"sectionInput":"ConceptDetailAddPage_sectionInput__9k+Vh"};